import { acomQnATexts, subaQnATexts, shopQnATexts } from './brand-texts';

const brandText = {
  acom: {
    ...acomQnATexts,
  },
  suba: {
    ...subaQnATexts,
  },
  shop: {
    ...shopQnATexts,
  },
};

const useTextOfBrand = ({ brand }) => (brandText[brand] ? brandText[brand] : brandText.acom);

useTextOfBrand.defaultProps = {
  brand: 'acom',
};

export { useTextOfBrand, brandText };
